module.exports = __webpack_public_path__ + "img/app_config.b274bfa0.png";